import { create } from 'zustand';

import { api } from 'src/utils/axios';

import { eventsDict } from 'src/_mock/_analytics';
import { AnalyticsRepository } from 'src/repositories/analytics/analytics.repository';

import { eventTypeItem } from 'src/types/analytics/analytics';

type States = {};

type Actions = {
  sendLogs: (params: { logs: eventTypeItem[] }) => Promise<void>;
  sendAuthErrorLog: (
    userName?: string,
    refreshToken?: string,
    accessToken?: string,
    token?: string | null
  ) => Promise<void>;
};

type Analytics = Actions & States;

const initialValues = {};

const analyticsRepository = new AnalyticsRepository(api);

export const useAnalyticsStore = create<Analytics>((set: any, get: any) => ({
  ...initialValues,

  sendLogs: async ({ logs }: { logs: eventTypeItem[] }) => {
    const response = await analyticsRepository.sendLogs({ logs });

    if (response.isLeft()) {
      throw new Error(response.value.message);
    }
  },

  sendAuthErrorLog: async (
    userName?: string,
    refreshToken?: string,
    accessToken?: string,
    token?: string | null
  ) => {
    let event = eventsDict.authError;
    const otherData = {
      ...event.otherData,
      userName,
      refreshToken,
      accessToken,
      token,
    };
    event = {
      ...event,
      otherData,
    };

    const response = await analyticsRepository.sendAuthErrorLog(event);

    if (response.isLeft()) {
      throw new Error(response.value.message);
    }
  },
}));
